import './styles/globals.css';

import Router from './router';
import { ThemeProvider } from '../components/providers/theme';
import { ReactNode, useEffect, useState } from 'react';
import { OpenAPI } from '../openapi';
interface Props {
  children: ReactNode;
}

interface AppConfig {
  BaseApiAddress: string;
}

export const TokenProvider: React.FC<Props> = ({ children }) => {
  const [config, setConfig] = useState<null | AppConfig>(null);

  useEffect(() => {
    // Путь к файлу в публичной директории
    fetch(`${process.env.PUBLIC_URL}/assets/config.json`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => setConfig(data))
      .catch((error) => console.error('Error fetching config:', error));
  }, []);

  if (!config) {
    return <div>Loading...</div>;
  }

  OpenAPI.TOKEN =
    JSON.parse(window.localStorage.getItem('user') ?? '{}')?.accessToken ?? '';
  OpenAPI.BASE = config.BaseApiAddress;

  return <>{children}</>;
};

export default function App() {
  return (
    <ThemeProvider>
      <TokenProvider>
        <Router />
      </TokenProvider>
    </ThemeProvider>
  );
}
